import { useTranslation } from "react-i18next";
import { useGetPublicUnitInfoQuery } from "@/features/accounting/warehouse";

interface Props {
  barcode: string;
}

export default function PublicUnitHeaderInfo({ barcode }: Props) {
  const { t, i18n, ready } = useTranslation("WarehousePage", { useSuspense: false });
  const { data: unit } = useGetPublicUnitInfoQuery(barcode, { skip: !barcode });

  const localeKey = i18n.language === "kk" ? "kk" : "ru";
  const orgName = unit?.organization_name ?? null;
  const orgAbbrev = unit?.organization_type_display?.[localeKey]?.abbreviation ?? null;
  const orgLabel = orgName ? (orgAbbrev ? `${orgAbbrev} «${orgName}»` : orgName) : null;

  if (!orgLabel) return null;

  return (
    <div className="flex flex-col">
      <p className="text-display-2xs content-base-primary">{orgLabel}</p>
      {unit?.organization_bin && ready && (
        <p className="text-body-regular-xs content-base-secondary">
          {t("publicUnit.orgBin")}: {unit.organization_bin}
        </p>
      )}
    </div>
  );
}
